import { Link } from "react-router-dom";
import type { User } from "@/app/types";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

interface NotFoundPageProps {
  user: User | null;
}

export function NotFoundPage({ user }: NotFoundPageProps) {
  const href = user ? "/dashboard" : "/";
  const label = user ? "Back to dashboard" : "Back to sign in";

  return (
    <div className="min-h-screen">
      <main className="container mx-auto grid min-h-screen max-w-3xl place-items-center px-6 py-12">
        <Card className="w-full max-w-md">
          <CardHeader>
            <CardTitle>Page not found</CardTitle>
            <CardDescription>The route you requested does not exist.</CardDescription>
          </CardHeader>
          <CardContent>
            <Button asChild>
              <Link to={href}>{label}</Link>
            </Button>
          </CardContent>
        </Card>
      </main>
    </div>
  );
}
